import {
  ExternalFeatureGetDto as ExternalFeatureGetDtoBase,
  SubscriptionPlan as SubscriptionPlanBase,
  SubscriptionPlanDetailsDto as SubscriptionPlanDetailsDtoBase,
  SubscriptionPlanFilterPostDto as SubscriptionPlanFilterPostDtoBase,
  SubscriptionPlanGetDto as SubscriptionPlanGetDtoBase,
  SubscriptionPlanLimits as SubscriptionPlanLimitsBase,
  SubscriptionPlanOptionsDto
} from "clearline-api";

/** @deprecated Use SubscriptionPlanGetDto from `clearline-api` instead */
export interface SubscriptionPlanGetDto extends SubscriptionPlanGetDtoBase {}

/** @deprecated Use import from `clearline-api` */
export interface SubscriptionPlan extends SubscriptionPlanBase {}

/** @deprecated Use import from `clearline-api` */
export interface SubscriptionPlanLimits extends SubscriptionPlanLimitsBase {}

/** @deprecated Use import from `clearline-api` */
export interface SubscriptionPlanOptions extends SubscriptionPlanOptionsDto {}

export interface SubscriptionPlanFeature {
  Name: string;
  Items: string[];
}

/** @deprecated Use import from `clearline-api` */
export interface SubscriptionPlanFilterPostDto extends SubscriptionPlanFilterPostDtoBase {}

/** @deprecated Use import from `clearline-api` */
export interface ExternalFeatureGetDto extends ExternalFeatureGetDtoBase {}

export interface SubscriptionPlanDetailsDto extends SubscriptionPlanDetailsDtoBase {}
